import Point from '@arcgis/core/geometry/Point';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import * as geometryEngine from '@arcgis/core/geometry/geometryEngine';

/**
 * Calculates the geodesic distance between two points in Web Mercator projection.
 *
 *
 * @param point1 - First point coordinates as [x, y] in Web Mercator (EPSG:3857)
 * @param point2 - Second point coordinates as [x, y] in Web Mercator (EPSG:3857)
 * @returns Distance between points in meters
 */
export const calculateDistance = (
  point1: number[],
  point2: number[],
): number | undefined => {
  try {
    const pointGeom1 = new Point({
      x: point1[0],
      y: point1[1],
      spatialReference: new SpatialReference({ wkid: 3857 }), // new spatial reference needed for geometryEngine
    });
    const pointGeom2 = new Point({
      x: point2[0],
      y: point2[1],
      spatialReference: new SpatialReference({ wkid: 3857 }), // new spatial reference needed for geometryEngine
    });

    // Use geometryEngine.distance for v4.23 compatibility
    return geometryEngine.distance(pointGeom1, pointGeom2, 'meters');
  } catch (error) {
    // fail silently
  }
};
